import { pb } from '../helpers/pocketbase_helper';
import { TareasExportService } from './TareasExportService';

export const CentroCostosExportService = {
  /**
   * Obtiene todos los centros de costo activos
   * @returns {Promise<Array>} Lista de centros de costo
   */
  async getCentrosCosto() {
    try {
      const result = await pb.collection('centro_costo').getList(1, 200, {
        filter: 'activo = true',
        expand: 'proceso,maquina,encargado,operario,proceso_proveedor',
        sort: 'nombre'
      });
      
      return result.items.map(centro => ({
        id: centro.id,
        nombre: centro.nombre,
        proceso: centro.expand?.proceso?.nombre || 'N/A',
        maquina: centro.expand?.maquina?.nombre || 'N/A',
        encargado: centro.expand?.encargado?.name || 'N/A',
        operario: centro.expand?.operario?.name || 'N/A',
        proceso_proveedor: centro.expand?.proceso_proveedor?.nombre || 'N/A',
        activo: centro.activo
      }));
    } catch (error) {
      console.error('Error fetching centros de costo:', error);
      throw new Error('Error al cargar centros de costo');
    }
  },

  /**
   * Exporta las tareas de un centro de costo específico
   * @param {string} centroCostoId - ID del centro de costo
   * @returns {Promise<void>}
   */
  async exportCentroCosto(centroCostoId) {
    try {
      if (!centroCostoId) {
        throw new Error('ID de centro de costo requerido');
      }

      // Obtener las tareas del centro de costo
      const tareas = await TareasExportService.getTareasByCentroCosto(centroCostoId);
      
      if (tareas.length === 0) {
        throw new Error('No hay tareas disponibles para exportar');
      }

      // Generar el archivo Excel
      await TareasExportService.generateExcel(centroCostoId, tareas);
      
    } catch (error) {
      console.error('Error exporting centro de costo:', error);
      throw error;
    }
  },

  /**
   * Obtiene un centro de costo específico por ID
   * @param {string} centroCostoId - ID del centro de costo
   * @returns {Promise<Object>} Centro de costo
   */
  async getCentroCostoById(centroCostoId) {
    try {
      const centro = await pb.collection('centro_costo').getOne(centroCostoId, {
        expand: 'proceso,maquina,encargado,operario,proceso_proveedor'
      });
      
      return {
        id: centro.id,
        nombre: centro.nombre,
        proceso: centro.expand?.proceso?.nombre || 'N/A',
        maquina: centro.expand?.maquina?.nombre || 'N/A',
        encargado: centro.expand?.encargado?.name || 'N/A',
        operario: centro.expand?.operario?.name || 'N/A',
        proceso_proveedor: centro.expand?.proceso_proveedor?.nombre || 'N/A',
        activo: centro.activo
      };
    } catch (error) {
      console.error('Error fetching centro de costo:', error);
      throw new Error('Error al cargar centro de costo');
    }
  }
};
